import { EBuildingClassType } from '../../../../json_query';
import { IWarehouseBuildingClassTypesTag } from '../../../state/tags/definitions/building_class_warehouse';
import { getMultiSelectionParamTagItem } from './fabrics/multi_selection_param_tag';

const getDisplayName = (value: string) => `Класс ${value}`;

const buildingClassMap = {
  [EBuildingClassType.A]: getDisplayName('A'),
  [EBuildingClassType.B]: getDisplayName('B'),
  [EBuildingClassType.C]: getDisplayName('C'),
  [EBuildingClassType.D]: getDisplayName('D'),
};

export const WarehouseBuildingClassTypesTagItem = getMultiSelectionParamTagItem<
  EBuildingClassType,
  IWarehouseBuildingClassTypesTag
>(buildingClassMap);
